var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "day-grid-week" },
    [
      _c(
        "div",
        { staticClass: "header-days" },
        _vm._l(_vm.dayLabels, function (day, index) {
          return _c("div", { key: day, staticClass: "day" }, [
            _c("label", { staticClass: "day-label" }, [
              _vm._v(_vm._s(day) + " " + _vm._s(_vm.dayNumberStart + index)),
            ]),
            _c(
              "div",
              {
                staticClass: "count-event",
                class: { "no-content": !_vm.countEvent[index] },
              },
              [_vm._v(_vm._s(_vm.countEvent[index]))]
            ),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "grid" }, [
        _c(
          "div",
          { staticClass: "scrollable-area" },
          _vm._l(7, function (dayNumber, dayIndex) {
            return _c(
              "div",
              {
                key: dayNumber,
                staticClass: "cell-day",
                class: { today: _vm.indexToday === dayIndex },
              },
              _vm._l(_vm.eventsByDay[dayIndex], function (event) {
                return _c(
                  "Event",
                  _vm._b(
                    {
                      key: event.id,
                      attrs: { isDraggable: false },
                      on: {
                        eventClick: function ($event) {
                          return _vm.$emit("eventClick", event.id)
                        },
                      },
                    },
                    "Event",
                    event,
                    false
                  )
                )
              }),
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "di",
        {
          staticClass: "btn-stacked-mode btn-radius",
          on: {
            click: function ($event) {
              return _vm.$emit("changeView", "timeGridWeek")
            },
          },
        },
        [
          _c("i", { staticClass: "fa-solid fa-angles-down" }),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("dash.posts.planner.expand")) +
              "\n    "
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }